import { createSelector } from 'reselect'

import {
  USER_IDS_WITH_FULL_ACCESS,
  ADMIN_USER_ROLE,
  DEVELOPER_USER_ROLE,
  DISPATCHER_USER_ROLE,
  PARTNER_USER_ROLE,
  LIMITED_DISPATCHER_USER_ROLE,
  ALIMAN_DISPATCHER_USER_ROLE,
  CARRIER_USER_ROLE,
  MODULTRANS_USER_ID,
} from 'constants/config'

const getState = state => state.user
const userRoleSelector = state => getState(state).role
const userIdSelector = state => getState(state).uid
const userNameSelector = state => getState(state).name
const usersSelector = state => getState(state).users
const historySelector = state => getState(state).history
const isLoadingSelector = state => getState(state).isLoading
const lineIdSelector = state => getState(state).lineId

const companySelector = createSelector(
  getState,
  ({ company }) => company
)

export const isModultransPartnerSelector = createSelector(
  userIdSelector,
  uid => uid === MODULTRANS_USER_ID
)

const isPrexBusSelector = createSelector(
  companySelector,
  company => company === 'prexbus'
)

const isPartnerSelector = createSelector(
  userRoleSelector,
  role => role === PARTNER_USER_ROLE
)

const isClientSelector = createSelector(
  userRoleSelector,
  role => role === 'client'
)

const isRoleSelector = createSelector(
  userRoleSelector,
  role => !!role
)

const isAdminSelector = createSelector(
  userRoleSelector,
  role => role === ADMIN_USER_ROLE || role === DEVELOPER_USER_ROLE
)

const isAlimanDispatcherSelector = createSelector(
  userRoleSelector,
  role => role === ALIMAN_DISPATCHER_USER_ROLE
)

const isDispatcherSelector = createSelector(
  userRoleSelector,
  role => role === DISPATCHER_USER_ROLE
)

const isDeveloperSelector = createSelector(
  userRoleSelector,
  role => role === DEVELOPER_USER_ROLE
)

const isCarrierSelector = createSelector(
  userRoleSelector,
  role => role === CARRIER_USER_ROLE
)

const isLimitedDispatcherSelector = createSelector(
  userRoleSelector,
  role => role === LIMITED_DISPATCHER_USER_ROLE
)

const bookingUsersSelector = createSelector(
  usersSelector,
  users => users.filter(({ role }) =>
    role === DISPATCHER_USER_ROLE
    || role === ADMIN_USER_ROLE
    || role === PARTNER_USER_ROLE
    || role === LIMITED_DISPATCHER_USER_ROLE
  )
)

const isUserWithFullAccessSelector = createSelector(
  userIdSelector,
  userId => USER_IDS_WITH_FULL_ACCESS.includes(userId)
)

export {
  usersSelector,
  userIdSelector,
  lineIdSelector,
  isRoleSelector,
  companySelector,
  historySelector,
  isAdminSelector,
  userRoleSelector,
  isClientSelector,
  userNameSelector,
  isCarrierSelector,
  isPartnerSelector,
  isPrexBusSelector,
  isLoadingSelector,
  isDeveloperSelector,
  bookingUsersSelector,
  isDispatcherSelector,
  isAlimanDispatcherSelector,
  isLimitedDispatcherSelector,
  isUserWithFullAccessSelector,
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/UserSelectors.js